export default __webpack_public_path__ + "media/src/assets/images/logo_icon-14b5256bd22a33b53b08911fa81bd2a5.svg";